import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFB95D', // md_theme_dark_primary
      light: '#FFDE9C', // md_theme_dark_onPrimaryContainer
      dark: '#462C00', // md_theme_dark_onPrimary
      contrastText: '#462C00', // md_theme_dark_onPrimary
    },
    secondary: {
      main: '#E4C18D', // md_theme_dark_secondary
      light: '#FFDEAC', // md_theme_dark_onSecondaryContainer
      dark: '#422C00', // md_theme_dark_onSecondary
      contrastText: '#422C00', // md_theme_dark_onSecondary
    },
    background: {
      default: '#0D1013', // md_theme_dark_background
      paper: '#0D1013',
    },
    text: {
      primary: '#E9E1D9', // md_theme_dark_onBackground
      secondary: '#E4C18D', // md_theme_dark_secondary
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(13, 16, 19, 0.8)',
          backdropFilter: 'blur(8px)',
        },
      },
    },
  },
}); 